import React, {useState, useEffect} from 'react';
import { __ } from '../../Lang.js';

const SearchHistory = ({ searchHistory, onHistoryItemClick }) => {

    /* searchHistoryQueries are triggeed by clicking on a search history term */
    const [searchHistoryQuery, setSearchHistoryQuery] = useState('');

    useEffect(() => {
        if (searchHistoryQuery) {
            // callback to parent component to handle the search history item click
            onHistoryItemClick(searchHistoryQuery);
        }
    }, [searchHistoryQuery]);

    return (
        <div className="search-history">
            <span className="search-history__label">{__('SEARCH HISTORY')}:</span>
           {searchHistory && searchHistory.length > 0 &&
                searchHistory.map((term, index) => (
                    <span
                        key={index}
                        className="search-history__term"
                        onClick={(e) =>{e.preventDefault(); setSearchHistoryQuery(term)}}
                    >
                        {term}
                    </span>
                ))
            }
        </div>
    );
};

export default SearchHistory;